/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopupPrepaidByOperatorTransaction
 */
export interface TopupPrepaidByOperatorTransaction {
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByOperatorTransaction
     */
    laundryGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByOperatorTransaction
     */
    backendUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof TopupPrepaidByOperatorTransaction
     */
    prepaidAccountId?: string;
}

/**
 * Check if a given object implements the TopupPrepaidByOperatorTransaction interface.
 */
export function instanceOfTopupPrepaidByOperatorTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TopupPrepaidByOperatorTransactionFromJSON(json: any): TopupPrepaidByOperatorTransaction {
    return TopupPrepaidByOperatorTransactionFromJSONTyped(json, false);
}

export function TopupPrepaidByOperatorTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopupPrepaidByOperatorTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'laundryGroupId': !exists(json, 'laundryGroupId') ? undefined : json['laundryGroupId'],
        'backendUserId': !exists(json, 'backendUserId') ? undefined : json['backendUserId'],
        'prepaidAccountId': !exists(json, 'prepaidAccountId') ? undefined : json['prepaidAccountId'],
    };
}

export function TopupPrepaidByOperatorTransactionToJSON(value?: TopupPrepaidByOperatorTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'laundryGroupId': value.laundryGroupId,
        'backendUserId': value.backendUserId,
        'prepaidAccountId': value.prepaidAccountId,
    };
}

